// SearchSuggestions.js
import React from "react";
import PropTypes from "prop-types";
 
const SearchSuggestions = ({
  products,
  onSelect,
  searchText,
  displayProperty = "productName",
}) => {
  const highlightMatch = (text) => {
    if (!searchText) return text;
    const regex = new RegExp(`(${searchText})`, "gi");
    const parts = String(text).split(regex);
    return parts.map((part, i) =>
      regex.test(part) ? (
        <span key={i} className="text-primary fw-bold">{part}</span>
      ) : (
        part
      )
    );
  };

  const getDisplayName = (product) =>
    product[displayProperty] || product.productName || "Unnamed Product";

  return (
    <div
      className="search-suggestions position-absolute top-100 start-0 end-0 bg-white border mt-1 rounded shadow-sm z-3"
      role="listbox"
      style={{ 
        cursor: 'pointer',
        maxHeight: '300px', // Set max height for scrolling
        overflowY: 'auto', // Enable vertical scrolling
        // Hide scrollbar but keep functionality
        scrollbarWidth: 'none',  /* Firefox */
        msOverflowStyle: 'none', /* IE and Edge */
      }}
    >
      {/* Add this style for Webkit browsers (Chrome, Safari) */}
      <style>
        {`
          .search-suggestions::-webkit-scrollbar {
            display: none;
          }
        `}
      </style>
      
      <ul className="list-group list-group-flush m-0">
        {products.map((product) => (
          <li
            key={product.id}
            role="option"
            tabIndex={-1}
            className="list-group-item list-group-item-action cursor-pointer"
            style={{ cursor: 'pointer' }}
            onPointerDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onSelect(product);
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <div className="fw-medium">
                  {highlightMatch(getDisplayName(product))}
                </div>
                {product.barcode && (
                  <small className="text-muted">Barcode: {product.barcode}</small>
                )}
              </div>
              <div className="text-end">
                <div className="fw-semibold">₹{product.price || 0}</div>
                {product.stockQuantity !== undefined && (
                  <small
                    className={
                      product.stockQuantity > 0 ? "text-success" : "text-danger"
                    }
                  >
                    {product.stockQuantity > 0
                      ? `In stock (${product.stockQuantity})`
                      : "Out of stock"}
                  </small>
                )}
              </div>
            </div>
          </li>
        ))}
        {products.length === 0 && (
          <li className="list-group-item text-muted">No products found</li>
        )}
      </ul>
    </div>
  );
};
 
SearchSuggestions.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      productName: PropTypes.string,
      price: PropTypes.number.isRequired,
      stockQuantity: PropTypes.number,
      barcode: PropTypes.string,
    })
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  searchText: PropTypes.string.isRequired,
  displayProperty: PropTypes.string,
};
 
export default SearchSuggestions;